import { render, staticRenderFns } from "./BaoSiManager.vue?vue&type=template&id=707b6606&scoped=true"
import script from "./BaoSiManager.vue?vue&type=script&lang=js"
export * from "./BaoSiManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b6606",
  null
  
)

export default component.exports